import en from '@/i18n/en.json';
import fr from '@/i18n/fr.json';

const customI18nMessages = {
    fr,
    en,
};

export default customI18nMessages;
